import React from 'react';
import { Database, Search, Plus, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';

export interface EmptyLibraryStateProps {
  variant: 'no-connectors' | 'no-matches';
  onAdd: () => void;
  onClear: () => void;
}

export const EmptyLibraryState: React.FC<EmptyLibraryStateProps> = ({
  variant,
  onAdd,
  onClear,
}) => {
  if (variant === 'no-connectors') {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-center">
        <Database className="h-16 w-16 text-muted-foreground mb-4" />
        <h3 className="text-xl font-semibold mb-2">No connectors yet</h3>
        <p className="text-muted-foreground mb-6 max-w-md">
          Add your first data source to start ingesting data into the lakehouse.
        </p>
        <Button onClick={onAdd}>
          <Plus className="h-4 w-4 mr-2" />
          Add Connector
        </Button>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <Search className="h-12 w-12 text-muted-foreground mb-4" />
      <h3 className="text-xl font-semibold mb-2">No connectors match your filters</h3>
      <p className="text-muted-foreground mb-6 max-w-md">
        Try adjusting your search query or removing some filters.
      </p>
      <Button variant="outline" onClick={onClear}>
        <RefreshCw className="h-4 w-4 mr-2" />
        Clear filters
      </Button>
    </div>
  );
};
